import fetchPlayedToursSaga from './fetchPlayedToursSaga';
import fetchCreatedToursSaga from './fetchCreatedToursSaga';
import cancelTourSaga from './cancelTourSaga';
import fetchStatisticsSaga from './fetchStatisticsSaga';

export default [...cancelTourSaga, ...fetchPlayedToursSaga, ...fetchCreatedToursSaga, ...fetchStatisticsSaga];
